import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/slices/authSlice";
import { isAuthenticated } from "../utils/authUtils";

/**
 * ProtectedRoute component - guards routes that require authentication
 * Redirects unauthenticated users to login page
 */
const ProtectedRoute = ({ children }) => {
  const user = useSelector(selectUser);
  const location = useLocation();

  // Check if user is authenticated using utility function
  const userIsAuthenticated = isAuthenticated(user);

  // If not authenticated, redirect to login with current location
  if (!userIsAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;
